var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FCB221;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54,55.7c-5,0-9-4.2-9-9.3V17.6c0-5.1,4-9.3,9-9.3s9,4.2,9,9.3v28.8C63,51.5,59,55.7,54,55.7z M54,15.4 c-1.1,0-2,1-2,2.2v28.8c0,1.2,0.9,2.2,2,2.2c1.1,0,2-1,2-2.2V17.6C55.9,16.4,55.1,15.4,54,15.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,55.7c-5,0-9-4.2-9-9.3v-5.8c0-5.1,4.1-9.3,9-9.3c5,0,9,4.2,9,9.3v5.8C19,51.5,15,55.7,10,55.7z M10,38.4 c-1.1,0-2,1-2,2.2v5.8c0,1.2,0.9,2.2,2,2.2c1.1,0,2-1,2-2.2v-5.8C12,39.4,11.1,38.4,10,38.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,55.7c-5,0-9-4.2-9-9.3V29.1c0-5.1,4.1-9.3,9-9.3c5,0,9,4.2,9,9.3v17.3C41,51.5,37,55.7,32,55.7z M32,26.9 c-1.1,0-2,1-2,2.2v17.3c0,1.2,0.9,2.2,2,2.2c1.1,0,2-1,2-2.2V29.1C34,27.9,33.1,26.9,32,26.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStat);
export default __webpack_public_path__ + "static/media/stat.43b9d7b4e6ec9ffb6ce3a7694528d274.svg";
export { ForwardRef as ReactComponent };